import { Component } from '@angular/core';
import { Animations, ErrorComponent } from '@vhv/tarifrechner-common';

@Component({
    animations: [Animations.slideInDownAnimation],
    templateUrl: '\error.component.html'
})
export class CyberErrorComponent extends ErrorComponent {


}
